export const API_BASE_URL = process.env.REACT_APP_API_URL;

// This helper function simply combines the base URL and the path.
// It no longer has special logic that breaks the URL.
export const getApiUrl = (path) => {
  return API_BASE_URL + path;
};
